import { Link } from 'react-router-dom'

import { PostStatus } from '@tribeplatform/gql-client/types'
import { T } from '@tribeplatform/react-components/i18n'
import { Badge } from '@tribeplatform/react-ui-kit/Badge'
import { DateValue } from '@tribeplatform/react-ui-kit/DateTimePicker'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

interface Props {
  status: PostStatus
  scheduledFor?: DateValue
}

export const StatusBadge = ({ status, scheduledFor }: Props) => {
  if (status !== PostStatus.DRAFT) {
    return null
  }
  const isScheduled = !!scheduledFor

  return (
    <div className="flex space-s-3 items-center">
      <Badge variant="attention">
        {isScheduled ? (
          <T id="Generics.Scheduled" defaultMessage="Scheduled" />
        ) : (
          <T id="Generics.Draft" defaultMessage="Draft" />
        )}
      </Badge>
      <Link
        to={`/settings/moderation/all/${
          isScheduled ? 'scheduled-posts' : 'draft-posts'
        }`}
        target="_blank"
        className="shrink-0 !p-0 text-xs text-action-primary flex gap-x-1 items-center"
      >
        <SvgIcon name="link-external" className="w-4 h-4" />
        <T id="Generics.ViewAll" defaultMessage="View all" />
      </Link>
    </div>
  )
}
